import { Navigate } from "react-router-dom";
import { UserAuth } from "../context/AuthContext";

const Protected = ({children}) =>{
    const {user, loading} = UserAuth();
    
    if (loading) {
        return <div className="loading">Loading...</div>;
    }
    
    if (!user){
        const currentSearchParams = new URLSearchParams(window.location.search);
        const preservedParams = currentSearchParams.toString();
    
        // Construct the new URL with preserved query parameters
        const redirectTo = `/signin${preservedParams ? `?${preservedParams}` : ''}`;

        return <Navigate to={redirectTo} />
    }
    
    // Check if email is verified (only for email/password users, Google users are pre-verified)
    // Check if user signed up with email/password by checking provider
    const isEmailPasswordUser = user.providerData && 
        user.providerData.some(provider => provider.providerId === 'password');
    
    if (isEmailPasswordUser && !user.emailVerified) {
        return <Navigate to="/verify-email" />
    }
    
    return children
}

export default Protected;